import { useMemo, useEffect, useState } from 'react'
import { Box, Container } from '@mui/material'
import { useNavigate, Outlet, useParams, generatePath } from 'react-router-dom'
import { HiringHeader } from '@/components/hiring'
import { useReadDeal } from '@/api/accounting-dealer'
import { routes } from '@/router'
import { ReadDealResponse } from '@/types'
import { Loading } from '@/components'

export function HiringPage() {
  const navigate = useNavigate()
  const { deal_key: dealKey } = useParams()

  const [dealResponse, setDealResponse] = useState<ReadDealResponse | null>(
    null,
  )

  const { data, isLoading } = useReadDeal(dealKey!, {
    enabled: Boolean(dealKey),
    staleTime: 0,
    gcTime: 0,
  })

  const routeByDealStep = useMemo(
    () => ({
      waiting_accept_proposal: routes.hiring.proposal,
      pre_programmed: routes.hiring.preContract,
      pre_programmed_postponed: routes.hiring.preContract,
      pre_programmed_lost: routes.hiring.preContract,
      waiting_main_partner_data: routes.hiring.mainPartner,
      waiting_company_data: routes.hiring.company,
      waiting_documents: routes.hiring.documents,
      waiting_signature: routes.hiring.contract,
    }),
    [],
  )

  useEffect(() => {
    if (!data || !dealKey) return

    const { step } = data.deal
    const targetRoute = routeByDealStep[step as keyof typeof routeByDealStep]
    if (!targetRoute) {
      navigate(routes.dashboard, { replace: true })
      return
    }

    setDealResponse(data)
    navigate(generatePath(targetRoute, { deal_key: dealKey }), {
      replace: true,
    })
  }, [data, dealKey, navigate, routeByDealStep])

  if (isLoading || !dealResponse) return <Loading />

  return (
    <Box>
      <HiringHeader />
      <Container component={'main'} maxWidth={'lg'} sx={{ pt: 4, pb: 4 }}>
        <Outlet context={dealResponse} />
      </Container>
    </Box>
  )
}
